import { useRef, useEffect } from 'react';

var useIsDestroyed = function useIsDestroyed() {
  var isDestroyed = useRef(false);
  useEffect(function () {
    return function () {
      isDestroyed.current = true;
    };
  }, []);
  return isDestroyed;
};

export { useIsDestroyed };